"use strict"

import jqueryCountUp from './modules/specifications-countup';
import lazyLoadImage from  './modules/lazy-image';
import fancyBox      from  './sliders-vertical-lib';
import variable from './variable';

(function ($) {


    let bodyTag = $('body');
    let menuTimeout;

    const getNextSection = (nextIndex = 1) => {
        return $('#main-content .section').eq(nextIndex - 1);
    };

    $('.clone-whats-in-seawind').each(function (index, elm) {
        if ($(elm).find('.fullheight.reverse').length > 0){

        }else{
            $(elm).addClass('section-nav-white');
        }
    });

    const initEachBlock = (theSection) => {
        let bodyTag = $('body');

        if (theSection.hasClass('section-light')) {
            $('#header').addClass('on-light-section');
            bodyTag.addClass('on-light-section');
        } else {
            $('#header').removeClass('on-light-section');
            bodyTag.removeClass('on-light-section');
        }

        if (theSection.hasClass('section-icon-menu-light')) {
            $('#header').addClass('on-icon-menu-light-section');
        } else {
            $('#header').removeClass('on-icon-menu-light-section');
        }

        if (theSection.hasClass('section-nav-red')){
            bodyTag.addClass('on-nav-red');
        }else{
            bodyTag.removeClass('on-nav-red');
        }

        if (theSection.hasClass('section-nav-white')){
            bodyTag.addClass('on-nav-white');
        }else{
            bodyTag.removeClass('on-nav-white');
        }


        if (theSection.is('.cs-image-gallery-third-grid')) {
            fancyBox(theSection);
        }

        if (theSection.is('.csBanner') || theSection.is('.clone-specifications')) {
            jqueryCountUp(theSection);
        }

        $(document).trigger('fullpage-loaded', theSection);
    };

    $(document).on('page-loaded', function () {
        // var event = new Event('scroll_direction');

        lazyLoadImage();

        var menuTimeout = undefined;
        if (!$('#main-content').find('article')[0] && detectOverWidth(992)) {
            setTimeout(function () {
                $('#main-content').fullpage({
                    navigation: true,
                    navigationPosition: 'left',
                    responsiveWidth: variable('bp_fullpage'),
                    lazyLoading: false,
                    css: true,
                    normalScrollElements: '.specs-fpage',
                    sectionSelector: '.section',
                    scrollOverflow: detectOverWidth(992),
                    afterLoad: function (origin, destination, direction) {
                        var next = getNextSection(destination);
                        initEachBlock(next);
                    },
                    onLeave: function (origin, destination, direction) {
                        if (origin && destination) {
                            clearTimeout(menuTimeout);
                            $(this).trigger('scroll_direction', [direction, destination]); // create custom event fire direction value when scroll
                            $(this).trigger('next_section', [origin, destination]); // create custom event fire id next section value when start scroll

                            if ($(window).width() > 1024) {
                                if (direction == 'down') {
                                    if (bodyTag.hasClass('menu-collapse')) {
                                        $('#toggle-nav-main-open').click();
                                    }
                                } else {
                                    if (!bodyTag.hasClass('menu-collapse')) {
                                        $('#toggle-nav-main-open').click();
                                    }

                                    menuTimeout = menuTrigger();
                                }
                            }
                        }
                    },
                    afterRender: function () {
                        $(this).trigger('fullpage_loaded');
                    },
                    afterResponsive: function (isResponsive) {
                        if (isResponsive) {
                            $('.fullscreen-section').css('height', "100%");
                            $('.fullscreen-section .fp-tableCell').css('height', "100%");
                            $('.fullscreen-section .fp-tableCell .grid-wrap').css('height', "100%");
                            $('.fullscreen-section .fp-tableCell .grid-wrap .news-container').css('height', "100%");
                        } else {
                            $('.fullscreen-section .fp-tableCell').height($('.fullscreen-section').height());
                            $('.fullscreen-section .fp-tableCell .grid-wrap').height($('.fullscreen-section').height());
                        }
                    }
                });
            }, 100);
        }
        if (!detectOverWidth(992)) {
            $(document).trigger('fullpage-loaded');

            lazyLoadImage();

            $('iframe').each(function (index, el) {
                let url = $(this).data('src');
                if (url) {
                    $(this).attr('src', url);
                }
            });
            $('video').each(function (index, el) {
                let url = $(this).data('src');
                if (url) {
                    $(this).attr('src', url);
                }
                $(this).removeAttr('data-src');
            });
        }
        $('iframe').each(function (index, el) {
            let url = $(this).attr('src');
            if (url) {
                $(this).attr('data-src', url);
            }
        });
    });

    $(window).resize(function () {
        if ($(window).width() < variable('bp_fullpage')) {
            $('.fullscreen-section').css('height', "100%");
            $('.fullscreen-section .fp-tableCell').css('height', "100%");
            $('.fullscreen-section .fp-tableCell .grid-wrap').css('height', "100%");
            $('.fullscreen-section .fp-tableCell .grid-wrap .news-container').css('height', "100%");
        }

        try {
            var menuTimeout = undefined;
            if (!$('#main-content').find('article')[0] && detectOverWidth(992)) {
                $.fn.fullpage.destroy('all');
                $('#main-content').fullpage({
                    navigation: true,
                    navigationPosition: 'left',
                    responsiveWidth: variable('bp_fullpage'),
                    lazyLoading: false,
                    css: true,
                    normalScrollElements: '.specs-fpage',
                    sectionSelector: '.section',
                    scrollOverflow: detectOverWidth(992),
                    afterLoad: function (origin, destination, direction) {
                        var next = getNextSection(destination);
                        initEachBlock(next);
                    },
                    onLeave: function (origin, destination, direction) {
                        if (origin && destination) {
                            clearTimeout(menuTimeout);
                            $(this).trigger('scroll_direction', [direction, destination]); // create custom event fire direction value when scroll
                            $(this).trigger('next_section', [origin, destination]); // create custom event fire id next section value when start scroll

                            if ($(window).width() > 1024) {
                                if (direction == 'down') {
                                    if (bodyTag.hasClass('menu-collapse')) {
                                        $('#toggle-nav-main-open').click();
                                    }
                                } else {
                                    if (!bodyTag.hasClass('menu-collapse')) {
                                        $('#toggle-nav-main-open').click();
                                    }

                                    menuTimeout = menuTrigger();
                                }
                            }
                        }
                    },
                    afterRender: function () {
                        $(this).trigger('fullpage_loaded');
                    },
                    afterResponsive: function (isResponsive) {
                        // console.log(isResponsive);
                        if (isResponsive) {
                            $('.fullscreen-section').css('height', "100%");
                            $('.fullscreen-section .fp-tableCell').css('height', "100%");
                            $('.fullscreen-section .fp-tableCell .grid-wrap').css('height', "100%");
                            $('.fullscreen-section .fp-tableCell .grid-wrap .news-container').css('height', "100%");
                        } else {
                            $('.fullscreen-section .fp-tableCell').height($('.fullscreen-section').height());
                            $('.fullscreen-section .fp-tableCell .grid-wrap').height($('.fullscreen-section').height());
                        }
                    }
                });
            }
        } catch (e) {
            // console.log(e;)
        }

        $('iframe').each(function (index, el) {
            let url = $(this).attr('src');
            if (url) {
                $(this).attr('data-src', url);
            }
        });
    });

    function detectOverWidth(width)
    {
        return ($(window).width() >= width);
    }

    function menuTrigger()
    {
        menuTimeout = setTimeout(()=>{
            if (bodyTag.hasClass('menu-collapse')) {
                $('#toggle-nav-main-open').click();
            }
        }, 3000);

        $('#nav-full-box').on('mouseenter', function () {
            clearTimeout(menuTimeout);
        });

        return menuTimeout;
    }

})(jQuery);
